export const messages = {
  addToHomeScreen: 'برای درسترسی سریع تر در آینده می‌توانید سامانه را نصب کنید',
  add: 'نصب سریع',
  forInstallation: 'برای نصب',
  dontShowAgain: 'دیگر نمایش داده نشود',
  pwa: 'نصب برنامه',
  iosStep1: '۱. دکمه Share را بزنید',
  iosStep2: '۲. گزینه Add To Home Screen را انتخاب کنید',
  iosStep3: '۳. دکمه Done را بزنید',
};
